import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function CtaSection() {
  const { t } = useTranslation();

  return (
    <section className="py-0 overflow-hidden">
      <div className="flex flex-col lg:flex-row min-h-[500px]">
        <div className="relative lg:w-1/2 h-64 lg:h-auto overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=adorable%20fluffy%20cat%20actively%20scratching%20and%20playing%20on%20a%20corrugated%20cardboard%20cat%20scratcher%20board%20in%20a%20bright%20cozy%20modern%20living%20room%20interior%20warm%20afternoon%20sunlight%20streaming%20through%20window%20natural%20wood%20flooring%20soft%20beige%20cream%20tones%20joyful%20happy%20pet%20moment%20lifestyle%20photography%20shallow%20depth%20of%20field%20golden%20hour%20lighting%20editorial%20quality&width=720&height=600&seq=cta-cat-scratcher-v2&orientation=landscape"
            alt="cat using scratcher"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent"></div>
          <div className="absolute bottom-8 left-8 right-8">
            <p className="text-white/70 text-xs mb-2">{t('cta_quote_label')}</p>
            <p className="text-white text-xl font-bold leading-snug">
              {t('cta_quote')}
            </p>
          </div>
        </div>

        <div className="lg:w-1/2 bg-white flex items-center justify-center px-10 md:px-16 py-16">
          <div className="max-w-md text-center">
            <div className="text-[#C8714A] text-xs font-semibold tracking-widest uppercase mb-4">
              {t('cta_label')}
            </div>
            <h2 className="text-3xl md:text-4xl font-bold text-[#1a1a1a] leading-tight mb-6">
              {t('cta_title1')}
              <br />
              {t('cta_title2')}
            </h2>
            <p className="text-[#888] text-sm leading-relaxed mb-8">
              {t('cta_desc')}
            </p>
            <Link
              to="/products"
              className="inline-flex items-center gap-2 px-8 py-4 rounded-full bg-[#C8714A] text-white font-semibold text-sm hover:bg-[#b5603b] transition-all cursor-pointer whitespace-nowrap"
            >
              {t('cta_btn')}
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
